/**
 * Map a ChatChannel / server broadcast payload (`data.message`) to the message
 * shape ChatPanel renders (the same shape as GraphQL `personalMessages`).
 *
 * Two rules matter for system notes (e.g. the Partial Sale Meeting Room
 * invitation, broadcast with sender id null):
 *   - a missing sender stays missing. String(null) is the truthy "null", which
 *     hid live system notes from MessageItem's `!message.sender?.id` checks, so
 *     the buyer saw raw markup and a stranger's avatar until they reloaded;
 *   - `system_authored` is true only when the payload says so explicitly. It is
 *     never inferred from a missing sender (MessageItem.jsx, PT41947_6).
 *
 * @param {object} payload - data.message from the socket
 * @returns {object} message for ChatPanel's list
 */
export const messageFromSocket = (payload) => {
  const sender = payload.sender || {};
  return {
    id: payload.id,
    body: payload.content,
    createdAt: payload.sent,
    sender: {
      id: sender.id == null ? null : String(sender.id),
      name: sender.name,
      allowed_name: sender.allowed_name,
      profile_picture: sender.profile_picture,
    },
    read: payload.read,
    messageType: payload.message_type || 'message',
    documents: payload.documents || [],
    system_authored: payload.system_authored === true,
  };
};

export default messageFromSocket;
